<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 標題" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="標題" class="mb-0">
							<el-input size="small" v-model="from.title" placeholder="搜索標題"></el-input>
						</el-form-item>
						<el-form-item label="編號" class="mb-0">
							<el-input size="small" v-model="from.notice_no" placeholder="搜索編號"></el-input>
						</el-form-item>
						
					

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" width="45" align="center">
				</el-table-column> -->

				<el-table-column align="center" prop="email_no" label="編號">
				</el-table-column>
					
				<el-table-column align="center" prop="name" label="發送人/接收人">
					<template slot-scope="scope">
						<span>
							<el-tag :type="scope.row.sender_class">{{scope.row.sender_name}}</el-tag>
							<el-tag :type="scope.row.receiver_class" >{{scope.row.receiver_name}}</el-tag>
						</span>
						
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="title" label="郵件標題">
								<template slot-scope="scope">
									<div v-if="scope.row.title.length > 20">
										{{ scope.row.title.substring(0, 20) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.title)">點擊查看</el-button>
									</div>
									<div v-else>
										{{ scope.row.title }}
									</div>
								</template>
					</el-table-column>
				
				<el-table-column align="center" width="100" prop="content" label="郵件內容">
						<template slot-scope="scope">
							<div slot="reference" style="cursor: pointer;" class="name-wrapper" @click="openDialog(scope.row,1)">
								<el-tag size="medium">查看</el-tag>
							</div>
						</template>
				</el-table-column>
				
			
                <el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button @click="reply(scope)" :disabled="scope.row.send_status == 0" v-auth="'delRule'" size="mini" plain type="success">回覆</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>


		<el-dialog  :close-on-click-modal="false" 
			title="回覆消息" 
			:visible.sync="createModel" 
			top="5vh" 
			:width="layout.is_phone ? '90%' : '80%'" 
			class="custom-dialog"
			>

			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone ? '80px' : '100px'" :label-position="layout.is_phone ? 'top' : 'left'">
			<template> 
				<el-descriptions class="margin-top" title="學校信息" :column="3"  border>
						
						<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							名稱
						</template>
						{{ form.sender_name }}
						</el-descriptions-item>
						
						<el-descriptions-item v-if="form.type == 3">
						<template slot="label">
                            <i class="el-icon-message"></i>
							
							郵件
						</template>
						{{ form.email }}
						</el-descriptions-item>
						<el-descriptions-item v-if="form.type == 3">
						<template slot="label">
							<i class="el-icon-mobile-phone"></i>
							電話
						</template>
						{{ form.phone }}
						</el-descriptions-item>
						
						<el-descriptions-item v-if="form.type == 3">
						<template slot="label">
							<i class="el-icon-map-location"></i>
							地址
						</template>
						{{ form.local }}
						</el-descriptions-item>
						
					</el-descriptions>

					<el-descriptions class="margin-top" title="郵件信息" :column="3" style="margin: 20px 0;">
						<el-descriptions-item label="编號"> {{ form.email_no }}</el-descriptions-item>
						<el-descriptions-item label="發送人">{{ form.sender_name }}</el-descriptions-item>
						<el-descriptions-item label="發送時間">
							{{ form.create_time }}
						</el-descriptions-item>
						
						<el-descriptions-item label="標題" :contentStyle="{'width': '80%'}">
							<!-- 限制高度並添加滾動條 -->
							
							{{ form.title }}
							
						</el-descriptions-item>
						<el-descriptions-item label="郵件内容"  :contentStyle="{'width': '90%'}">
							<!-- 限制高度並添加滾動條 -->
							<div class="email-content">
							{{ form.content }}
							</div>
						</el-descriptions-item>
					</el-descriptions>
			</template>
				<!-- 顶部信息展示区 -->
			

				<!-- 回复標題輸入 -->
				<el-form-item label="回覆標題" prop="reply_title">
				<el-input 
					type="text" 
					v-model="form.reply_title"
					maxlength="50"
					show-word-limit
					placeholder="回覆標題"
					clearable 
					size="small" 
					class="form-input"
				/>
				</el-form-item>

				<!-- 回复内容輸入 -->
				<el-form-item label="回覆内容" prop="reply_content">
				<el-input 
					type="textarea" 
					:rows="3" 
					v-model="form.reply_content"
					maxlength="200"
					show-word-limit
					placeholder="回覆内容"
					clearable 
					size="small" 
					class="form-input"
				/>
				</el-form-item>

			</el-form>

			<!-- 底部按钮 -->
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取消</el-button>
				<el-button type="primary" @click="submit">發送</el-button>
			</div>
		</el-dialog>


		<el-dialog  :close-on-click-modal="false" 
			:visible.sync="dialogVisible" 
			:width="layout.is_phone ? '90%' : '70%'" 
			title="郵箱信息" 
			@close="closeDialog"
			>
			<!-- 郵件信息头部 -->
			<div v-if="dialogType == 1" class="dialog-header">
				<div class="email-info">
				<p><strong>標題：</strong> {{ emailTitle }}</p>
				<p><strong>發送人：</strong> {{ senderName }}</p>
				<p><strong>發送時間：</strong> {{ sendTime }}</p>
				</div>
			</div>
			
			
			<!-- 郵件内容 -->
			<div v-html="dialogContent" class="dialog-content"></div>
			
			<!-- 弹框底部 -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeDialog">關閉</el-button>
			</span>
		</el-dialog>

		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>
		<el-dialog  :close-on-click-modal="false" :visible.sync="dialogTitleVisible" title="發送標題">
			<p>{{ fullTitle }}</p>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				dialogTitleVisible: false,
				fullTitle: '',
				
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					title: '',
					notice_no: '',
					content:'',
					type:'-1',
					status:'-1',
					uid:'',
					time: [],
				},
				model_title: 'Notice',
				auth_val: 'Notice',
				preUrl: "data/EmailList", //列表地址
				addUrl: "data/addEmail", //回覆郵件
                editStatusUrl: "data/editStatusEmail", //修改狀態地址

				tableData: [],
				form: {
					id: 0,
					title:'',
					content:"",
				},
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],

				school_list: [],
				inst_list: [],
				user_list: [],
				
				dialogVisible: false,      // 控制對話框顯示
				dialogContent: '' ,         // 存储當前对话框的内容

				emailTitle: '' ,         // 
				senderName: '' ,         // 
				sendTime: '' ,         // 
				dialogType:1,
				rules: {
					reply_content: [{
							required: true,
							message: "回覆內容不能為空",
							trigger: 'blur',
						},
					],
					reply_title: [{
							required: true,
							message: "回覆標題不能為空",
							trigger: 'blur',
						},
					],
				
					
				},

			}
		},
		
		methods: {
			reply(e){
				// 初始化表單數據
				this.form = {
					id: e.row.id,
					ins_id: e.row.ins_id,
					title: e.row.title,
					email_no: e.row.email_no,
					create_time: e.row.create_time,
					content: e.row.content,
					local: e.row.local,
					email: e.row.email,
					phone: e.row.phone,
					sender_name: e.row.sender_name,
					type: e.row.type,
					admin_type: 2,
					reply_content: '',
					reply_title: '',
				};
				this.editIndex = e.row.id;
				this.createModel = true;
			},
			 // 顯示完整標題内容
			 showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
			openDialog(row,type) {
				if(type == 2){
					this.dialogContent = row.reply_content; // 设置要顯示的 HTML 内容
				}else{
					this.dialogContent = row.content; // 设置要顯示的 HTML 内容
				}
				
				this.dialogType = type; // 设置要顯示的 HTML 内容
				this.emailTitle = row.title; // 设置要顯示的 HTML 内容
				this.senderName = row.sender_name; // 设置要顯示的 HTML 内容
				this.sendTime = row.create_time; // 设置要顯示的 HTML 内容
			
				if(row.status == 0){
					this.changeStatus(row,1,false,true)
				}
				this.dialogVisible = true;    // 顯示对话框
			},
			closeDialog() {
				this.dialogVisible = false;   // 關閉对话框
				this.dialogContent = '';      // 清空内容
				this.dialogTitle = '';      // 清空内容
			},

			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
                   
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				// if (!isJPG) {
				//   this.$message.error('上傳头像图片只能是 JPG 格式!');
				// }
				// if (!isLt2M) {
				//   this.$message.error('上傳头像图片大小不能超過 2MB!');
				// }
				return isJPG && isLt2M;
			  },
			

			// 打开模态框
			openModel(e, type) {
				console.log(e)
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						title: e.title,
						content: e.content,
						appoint_id:e.appoint_id,
						all_type:e.all_type,
					}
					this.editIndex = e.id
				}else{
					this.form = {
						id: 0,
						title:'',
						content:"",
						appoint_id:0,
						all_type:0,
					}
					this.editIndex = -1
				}
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					title: '',
					notice_no: '',
					content:'',
					type:'-1',
					status:'-1',
					uid:'',
					time: [],
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.dialog-header {
  border-bottom: 1px solid #ebeef5;
  padding: 10px 20px;
  margin-bottom: 15px;
}

.email-info p {
  margin: 0;
  font-size: 14px;
  color: #606266;
}

.dialog-content {
  padding: 10px 20px;
}
/* 对话框整体样式 */
.custom-dialog {
  border-radius: 8px; /* 圆角边框 */
  overflow: hidden; /* 防止溢出 */
}

/* 顶部信息样式 */
.dialog-header {
  padding: 15px 20px;
  background-color: #f5f7fa; /* 添加背景色 */
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 15px;
}

.email-info p {
  margin: 0;
  color: #606266;
  font-size: 14px;
  line-height: 1.6;
}

/* 輸入框样式 */
.form-input {
  width: 100%;
  margin-bottom: 10px;
}

/* 底部按钮样式 */
.dialog-footer {
  padding: 10px 20px;
  text-align: right;
}

.dialog-footer .el-button:first-child {
  margin-right: 10px;
}

/* 改进按钮样式 */
.el-button--primary {
  background-color: #409eff;
  border-color: #409eff;
  color: #fff;
}
.el-button--primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

/* 限制郵件内容高度並添加滾動條 */
.email-content {
  max-height: 100px; /* 限制高度 */
  overflow-y: auto; /* 添加垂直滾動條 */
  word-break: break-word; /* 避免內容溢出 */
  padding: 5px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #f9f9f9;
}
</style>
